var $class="se2--application-social-media-share-horizontal",$name="ApplicationSocialMediaShareHorizontal",$path="app/components/ApplicationSocialMediaShareHorizontal/config.js",$this={$class,$name,$path,};export const printButtonSelector = '.print';
export const socialLinkSelector = '.social-link';
export const placeholderInUrl = '%7BinitialPageUrl%7D';
